import { object, string } from "yup";

const validationSchema = object().shape({
  code: string().required("You must enter a Code"),
});

export default () => validationSchema;
